// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import bell01Icon from "@/assets/icons/bell-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Bell01IconProps = Omit<IconProps, "name">;

export function Bell01Icon(props: Bell01IconProps): React.ReactNode {
  return <Icon name={bell01Icon} {...props} />;
}
